import React from 'react';
import LinkIcon from '@material-ui/icons/Link';

import { Link, LinkType } from 'types';
import { EditableList } from 'components/List';
import { UPDATE_SHOW_LINK } from 'graphql/show';

import LinksDialog from './LinksDialog';

interface Props {
  title: string;
  linkType: LinkType;
  links: Link[];
  itunesId: string;
}

export const EditableLinksList: React.FC<Props> = (props) => {
  const { links, itunesId, title, linkType } = props;

  const isDefaultWithValue = (l: Link): boolean => !!l.isDefault && l.link !== '';
  const filterLinksFn = (l: Link) => l.type === linkType && (!!l.isCustom || isDefaultWithValue(l));
  const filteredLinks = links.filter(filterLinksFn);

  const renderEditDialog = (isOpen: boolean, onClose: () => void, selectedLink?: Link) => (
    <LinksDialog
      title={title}
      type={linkType}
      isOpen={isOpen}
      itunesId={itunesId}
      link={selectedLink}
      onClose={onClose}
    />
  );

  return (
    <EditableList
      title={title}
      itunesId={itunesId}
      identifier="slug"
      items={filteredLinks}
      primaryTextKey="link"
      secondaryTextKey="label"
      inputItemNameKey="link"
      updateMutation={UPDATE_SHOW_LINK}
      renderLeftIcon={() => <LinkIcon />}
      renderEditDialog={renderEditDialog}
    />
  );
};
